const FILE_MIME_TYPES = {
  docx: {
    name: 'docx',
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  },
  doc: { name: 'doc', type: 'application/msword' },
  pptx: {
    name: 'pptx',
    type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  },
  ppt: { name: 'ppt', type: 'application/vnd.ms-powerpoint' },
  pdf: { name: 'pdf', type: 'application/pdf' },
  xlsx: {
    name: 'xlsx',
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  },
  xls: { name: 'xls', type: 'application/vnd.ms-excel' },
  txt: { name: 'txt', type: 'text/plain' }
};

const otherValue = {
  Name: 'Other',
  AllowedTypes: [
    FILE_MIME_TYPES.doc,
    FILE_MIME_TYPES.docx,
    FILE_MIME_TYPES.ppt,
    FILE_MIME_TYPES.pptx,
    FILE_MIME_TYPES.pdf,
    FILE_MIME_TYPES.xls,
    FILE_MIME_TYPES.xlsx,
    FILE_MIME_TYPES.txt
  ]
};

export const MDDAP_CHECK_POINTDOCUMENT_TYPES = {
  CheckPointReport: 0,
  ReappraisalRationale: 1,
  OtherFirst: 2,
  OtherSecond: 3,
  OtherThird: 4
};

export const checkPointDocumentsMap = new Map([
  [
    MDDAP_CHECK_POINTDOCUMENT_TYPES.CheckPointReport,
    {
      Name: 'Check Point Report',
      AllowedTypes: [FILE_MIME_TYPES.doc, FILE_MIME_TYPES.docx]
    }
  ],
  [
    MDDAP_CHECK_POINTDOCUMENT_TYPES.ReappraisalRationale,
    {
      Name: 'Reappraisal Rationale',
      AllowedTypes: [FILE_MIME_TYPES.doc, FILE_MIME_TYPES.docx]
    }
  ],
  [MDDAP_CHECK_POINTDOCUMENT_TYPES.OtherFirst, otherValue],
  [MDDAP_CHECK_POINTDOCUMENT_TYPES.OtherSecond, otherValue],
  [MDDAP_CHECK_POINTDOCUMENT_TYPES.OtherThird, otherValue]
]);
